<template>
  <BaseCustomizeMetal componentCode="AB" useNotReverse />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAB",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 140px;
    left: 111px;
    @include betweenTableTablePro {
      top: 101px;
      left: 61px;
    }
    @include table {
      top: 80px;
      left: 36px;
    }
    @include phone {
      top: 65px;
      left: 21px;
    }
  }
  .templeName {
    height: 33px;
    width: 279px;
    justify-content: center;
    .textContainer {
      width: 235px;
    }
  }
  .godName {
    width: 279px;
    height: 58px;
    margin: 6px auto;
    .textContainer {
      width: 279px;
    }
  }
  .gift {
    width: 210px;
    height: 33px;
    justify-content: center;
    position: absolute;
    top: 103px;
    left: 0;
    .textContainer {
      width: 171px;
    }
  }
  .respect {
    position: absolute;
    top: 106px;
    left: 233px;
  }
}
</style>
